import { createContext, useContext } from 'react';
import { AuthUser } from './types';

export const AuthContext = createContext<{
  authUser: AuthUser;
  selectOrgs(orgs: string[]): void;
} | null>(null);

export const useAuthUser = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuthUser must be used within a AuthProvider');
  }
  return context;
};
